exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#dashboard[data-v-cfb92aca]{padding-left:3%;padding-right:3%}h1[data-v-cfb92aca]{text-align:left}.contratos[data-v-cfb92aca]{text-align:left;padding-left:10%}.pastContracts[data-v-cfb92aca]{text-align:left;padding-top:20px}.button-contract[data-v-cfb92aca]{border:1px solid #3b3b3b;color:#3b3b3b;padding:10px 20px;font:inherit;cursor:pointer;margin-top:10px;width:280px}#viewer[data-v-cfb92aca]{padding-top:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-cfb92aca","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/contractView/contractViewer.vue
// module id = 524
// module chunks = 0